import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { FormattedMessage } from 'react-intl';
import withSpinner from './../../reusable/Wrappers/SpinnerWrapper/SpinnerWrapper';
import SanctionsWarningsTable from './../../pages/SanctionsWarnings/SanctionsWarningsTable';
import TabbedContent from './../../reusable/TabbedContent/TabbedContent';
import PreviousPageLink from './../../reusable/PreviousPageLink/PreviousPageLink';
import api from './../../api/Common.api';
import headerActions from './../../reusable/Header/Header.actions';
import xhr from './../../utils/xhr';
import LoadingSpinner from './../../reusable/Wrappers/LightSpinnerWrapper/LightSpinnerWrapper';
import { find } from 'lodash';

class SanctionsWarningsTabbedListingPage extends Component {

    static propTypes = {
        items: PropTypes.array,
        index: PropTypes.number,
        loadItems: PropTypes.func,
        router: PropTypes.any,
        entityName: PropTypes.string,
        cisIds: PropTypes.array,
        cisIdCodes: PropTypes.array
    };

    static defaultProps = {
        entityName: null
    };

    constructor(props) {
        super(props);

        this.goBack = this.goBack.bind(this);

        this.state = {
            entityName: null,
            companyId: props.params.companyId
        }
    }

    componentWillMount() {
        this.props.spinner.showSpinner();
        window.scrollTo(0, 0);
        api.loadCompanyData(this.props.params.companyId).then((res) => {
            this.setState({
                entityName: res.companyTitle
            }, () => {
                this.props.spinner.hideSpinner();
                this.props.loadItems(res.companyTitle, this.props.params.companyId);
                headerActions.updateHeaderContent(
                    <div>
                        {this.state.entityName}: <FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.overlayHeader"/>
                    </div>,
                    'sanctionstips-field?lbu=US&locale=en_US&audience=all'
                );
            })
        }).catch((error) => {
            xhr.handleAllErrors(error);
        })
    };

    goBack() {
        this.props.router.push("/start");
    }

    getSanctionItems = (cisId) => this.props.items ? this.props.items.filter(item => item.cisID === cisId) : null;

    getCisId(id) {
        if (this.props.cisIds) {
            const cisIdItem = find(this.props.cisIds, (o => o.id === id));
            if (cisIdItem) {
                return {
                    totalCount: cisIdItem.totalCount,
                    hasError: cisIdItem.hasError,
                    isFinished: cisIdItem.isFinished
                }
            }
        }
        return null;
    }

    loadItems(entityName, companyId) {
        this.props.loadItems(entityName, companyId);
    }

    render() {
        let hasGeneralError = true;
        let activeTabIndex = null;
        let emptyTabs = 0;
        const tabs = this.props.cisIdCodes.map((cisId, index) => {
            const cisIdData = {
                ...this.getCisId(cisId.id),
                items: this.getSanctionItems(cisId.id),
                cisID: cisId.id
            };

            const isDisabled = cisIdData.items.length === 0 && cisIdData.hasError === false;

            if (isDisabled) {
                emptyTabs++;
            } else {
                hasGeneralError = false;
                if (activeTabIndex === null) {
                    activeTabIndex = index;
                }
            }

            return {
                id: cisId.id,
                label: cisId.type,
                content: !isDisabled && <SanctionsWarningsTable companyId={this.props.params.companyId}
                                                                entityName={this.state.entityName}
                                                                loadItems={this.props.loadItems}
                                                                listingPage
                                                                {...cisIdData} />
            }
        });

        return (
            <div className="sanction-reports__list">
                <PreviousPageLink location="/start" text="General_CoreFunctionality_UIText_general.backToPreviousPage" />
                { (this.props.totalCount === null || this.props.totalCount === 0) && this.props.isLoading ?
                    <LoadingSpinner isLoading sizeLarge/> : (
                        hasGeneralError ?
                            <div className="no-entries">
                                { emptyTabs === tabs.length ?
                                    <div>
                                        <span><b>{this.state.entityName}</b> </span>
                                        <FormattedMessage id="Dashboard_SingleView_UIText_sanctionsAndWarnings_noSanctions" />
                                    </div>
                                    : <FormattedMessage id={"Entities_Dossier_UIText_dossierServiceUnavailable"}/>
                                }
                            </div>
                            : <TabbedContent tabs={tabs} defaultTabIndex={activeTabIndex} />
                    )
                }
            </div>
        )
    };
}

export default withSpinner(withRouter(SanctionsWarningsTabbedListingPage));



// WEBPACK FOOTER //
// ./src/scripts/pages/SanctionsWarnings/SanctionsWarningsTabbedListingPage.jsx